exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TEXTFIELD */\n\n/* LIST */\n\n/* ==========  Layout  ========== */\n\n/* BUTTON */\n\n/* ANIMATION */\n\n/* Small control size */\n\n.close-button {\n  position: absolute;\n  right: 25px;\n  padding: 20px;\n}\n\n:host {\n  flex-direction: column;\n  flex-grow: 1;\n  display: flex;\n  width: 100%;\n}\n\n:host .kit-detail-container {\n  flex-direction: column;\n  flex-grow: 1;\n  display: flex;\n  overflow-y: auto;\n}\n\n", ""]);

// exports
